import { BarLoader } from 'react-spinners';
import React from 'react'

export const DefaultLoader = ({height, color}) => {
    return (
        <BarLoader
        width={height || 200}
        color={color || '#2e5bec'} 
        />
    )
}